import {Component, EventEmitter, forwardRef, Inject, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {IAppliedFiltersUpdater, IAppliedFiltersUpdaterToken} from '../../applied-filters-updater';
import {AdvancedFilterOperatorEnum, AdvancedFiltersOperatorTranslations, AdvanceFilterParamType} from '../advance-filter';

@Component({
    selector: 'app-operator-selector',
    templateUrl: './operator-selector.component.html',
    styleUrl: './operator-selector.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OperatorSelectorComponent),
            multi: true
        }
    ]

})

export class OperatorSelectorComponent implements ControlValueAccessor {
    @Input() items: AdvancedFilterOperatorEnum[] = [];
    @Input() value: string;
    @Output() valueChange: EventEmitter<string> = new EventEmitter();
    protected readonly AdvancedFiltersOperatorTranslations = AdvancedFiltersOperatorTranslations;
    protected isDisabled: boolean = false;

    constructor(@Inject(IAppliedFiltersUpdaterToken) private filterUpdater: IAppliedFiltersUpdater<AdvanceFilterParamType>) {
    }

    private onChange: (value) => void;
    private onTouched: () => void;

    writeValue(value: string): void {
        this.value = value
    }

    registerOnChange(fn): void {
        this.onChange = fn;
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    onModelChange($event) {
       this.valueChange.next($event);
        if (this.onChange) {
            this.onChange($event);
        }
    }

    onControlTouched() {
        if (this.onTouched) {
            this.onTouched();
        }
    }
}
